// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"369":"090479a0ce69846a","2835":"260f728284d2fef3","9823":"090479a0ce69846a","9840":"c2c90e504f524dbe"}[chunkId] + ".css";
};